const Colors = [
    [
        "#040309",
        "#3bca9e",
        "#1eb4eb",
        "#FFFFFF",
        "#f45d13",
        "#e794d4",
        "#ffce15",
    ], 
    [
        "#131F1D",
        "#083CE0",
        "#CA7B4F",
        "#C5DE49",
        "#D6D9DB",
        "#00D9A5",
    ], 
    [
        "#131F1D",
        "#083CE0",
        "#CA7B4F",
        "#C5DE49",
        "#D6D9DB",
        "#00D9A5",
    ], 
    [
        "#131F1D",
        "#3347B0",
        "#E8B4E7",
        "#CCF6E8",
    ], 
    [
        "#000000",
        "#9c52f2",
        "#b85e00",
        "#9c52f2",
        "#730f1f",
        "#9c52f2",
    ], 
    [
        "#000000",
        "#9c52f2",
        "#9c52f2",
        "#9c52f2",
        "#ffbf6e",
        "#9c52f2",
        "#9c52f2",
        "#0024cc",
        "#9c52f2",
        "#9c52f2",
    ], 
    [
        "#000000",
        "#0024cc",
        "#0024cc",
        "#ffbf6e",
        "#0024cc",
        "#0024cc",
        "#9c52f2",
        "#0024cc",
    ], 
    [
        "#000000",
        "#0024cc",
        "#0024cc",
        "#ffbf6e",
        "#0024cc",
        "#0024cc",
        "#9c52f2",
        "#0024cc",
    ], 
    [
        "#000000",
        "#ffbf6e",
        "#a6d40d",
        "#651300",
    ], 
    [
        "#000831",
        "#00d973",
        "#fa2b00",
        "#00d973",
        "#fa2b00",
        "#00d973",
        "#fa2b00",
        "#0000ff",
    ], 
    [
        "#3400a3",
        "#d50c42",
        "#19cc33",
    ],
    [
        "#111111",
        "#fefcfb",
    ],
    [
        "#111111",
        "#fefcfb",
    ],
    [
        "blue",
        "#ffffff",
    ], 
    [
        "blue",
        "#ffffff",
    ], 
    [
        "#000000",
        "#ff5ec4",
        "#a93400",
        "#1b8e13",
    ], 
    [
        "#00592e",
        "#fff",
        "#fff",
        "#fff",
        "#fff",
        "#fff",
        "#fff",
        "#fff",
        "#fff",
        "#fff",
        "#ff0000",
        "#ffff00",
        "#0E8DD2",
    ], 
    [
        "#0f261f",
        "#ffab00",
        "#bfabcc",
        "green",
    ], 
    [
        "#3400a3",
        "#ffab00",
        "#b319ab",
        "#ff5ec4",
        "green",
    ], 
    [
        "#0f261f",
        "#e0b81f",
        "#faed8f",
        "#e62e73",
        "#e0b81f",
        "#faed8f",
        "#e62e73",
        "#e0b81f",
        "#faed8f",
        "#e62e73",
        "#0E8DD2",
    ],
    [
        "#06004f",
        "#cc1a97",
        "#9161f2",
        "#2619d1",
        "#ffb852",
        "#fa3219",
        'green'
    ],
    [
        "#06004f",
        "#cc1a97",
        "#9161f2",
        "#2619d1",
        "#ffb852",
        "#fa3219",
        'green'
    ],
    [
        "#172713",
        "#718600",
        "#f2ad78",
        "#f5f5b8",
        "#718600",
        "#f2ad78",
        "#f5f5b8",
        "#718600",
        "#f2ad78",
        "#f5f5b8",
        "#2619d1",
    ],
    [
        "#172713",
        "#718600",
        "#f2ad78",
        "#f5f5b8",
    ],
    [
        "#172713",
        "#00592e",
        "#d50c42",
        "#ff7399",
        "#00592e",
        "#d50c42",
        "#ff7399",
        "#FABF01",
    ],
    [
        "#172713",
        "#8c6510",
        "#ffb852",
        "#ffa6d9",
    ],
    [
        "#172713",
        "#328e13",
        "#ff616b",
        "#a6e6db",
    ],
    [
        "#10120F",
        "#F44A0F",
        "#0E8DD2",
        "#10971F",
        "#5AA316",
        "#E53F0F",
    ],
    [
        "#1f1816",
        "#FABF01",
        "#125FAF",
        "#01886A",
        "#6B5B99",
        "#E90013",
        "#FAEAD1",
    ],
    [
        "#020202",
        "#00BB70",
        "#0075CA",
        "#FDDC3F",
        "#FF6936",
    ],
    [
        "#2A1F1D",
        "#F0E0C6",
        "#DF4A33",
        "#FBAF3C",
        "#2A1F1D",
        "#7A999C",
        "#475B62",
    ],
    [
        "#022D8F",
        "#f9cd22",
        "#14a160",
        "#e94e19",
        "#203b75",
        "#cc0028",
    ],
    [
        "#000000",
        "#f1594a",
        "#14a160",
        "#acc1bc",
        "#d38e1a",
    ],
    [
        "#000000",
        "#4D545A",
        "#E4A13A",
        "#C15E1F",
        "#14a160",
    ],
    [
        "#1E1A43",
        "#F5D4BC",
        "#4E4973",
        "#CD902A",
        "#BF4A2B",
    ],
   
    [
        "#1E1A43",
        "#F5D4BC",
        "#4E4973",
        "#CD902A",
        "#BF4A2B",
    ],
    [
        "#0609b1",
        "#ffffff",
        "#f0292f",
        "#fb6119",
        "#3e8741",
    ],
    [
        "#2619d1",
        "#ebd999",
        "#9b5348",
        "#00592e",
    ],
    [
        "#000000",
        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    [
        "#000000",
        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    [
        "#000000",
        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    [
        "#06004f",
        "#202d85",
        "#f2ff26",
        "#bdf226",
        "#202d85",
        "#f2ff26",
        "#bdf226",
        "#202d85",
        "#f2ff26",
        "#bdf226",
        "#202d85",
        "#f2ff26",
        "#bdf226",
        "#d50c42",
        "#9161f2",
    ],
]
export default Colors